import { defineStore } from "pinia";
import { watch } from "vue";
import { useVideoIdentStore } from "./VideoIdentStore";

export const useAppStore = defineStore("AppStore", {
  state: () => {
    return {
      currentLanguage: "DE",
      activeStep: 0,
      // activeStepInvite: 1,
      screenNumbers: {
        home: 1,
        identity: 2,
        email: 3,
        offer: 4,
        contractDetail: 5,
        furtherInformation: 6,
        // videoIdentWelcome: 7,
        // videoIdent: 8,
        // videoIdentSuccess: 9,
        // videoIdentFailed: 10,
      },
      isInvitedUser: false,
      header: "sidebar.steps.membership",
      // Usually 1, can be changed for translation pluralization
      headerNum: 1,
      btnForward: "Weiter",
      btnBack: "Zurück",
      // Route
      routeHome: "/#",
      routeIdentity: "/membership-order",
      routeEmail: "/membership-email",
      routeOffer: "/membership-offer",
      routeContract: "/membership-contract-detail",
      // Token we get from backend after screen 4
      token: "",
      csrfToken: "",
    };
  },
  actions: {
    getCsrfTokenFromCookie(cookie) {
      this.csrfToken = cookie
        .split('; ')
        .find(row => row.startsWith('ObSSOCookie='))
        ?.split('=')[1];
      return this.csrfToken || null;
    },
    changeHeader(router) {
      watch(router, (to) => {
        if (to.path === "/") {
          this.header = "sidebar.steps.membership";
        } else if (to.path === "/membership-order") {
          this.header = "sidebar.steps.identities";
        } else if (to.path === "/membership-email") {
          this.header = "sidebar.steps.hinEmailSelect";
        } else if (to.path === "/membership-offer") {
          this.header = "sidebar.steps.offer";
        } else if (to.path === "/membership-contract-detail") {
          this.header = "sidebar.steps.contractDetail";
        } else if (to.path === "/further-information") {
          this.header = "sidebar.steps.furtherInfo";
        } else if (to.path === "/id-registration-confirmation") {
        } else this.header = "sidebar.steps.membership";
      });
    },


    async handleIdentInvitation() {
      const videoIdentStore = useVideoIdentStore();
      const params = new URLSearchParams(window.location.search);

      // In case a second invited user opens their link in the same
      // browser tab, they need videoIdentStore reset or else they
      // immediately view "everything done" page.
      // It is a bit unfortunate that videoIdentStore.validateToken
      // sends this.token instead of getting it from params.
      // In any case, if anybody comes here with a token in the request
      // and the store has data which does not belong to the token presented
      // it looks like a good idea to reset the store.
      if (params.has('invitation') && params.get('invitation') !== videoIdentStore.token) {
        let token = params.get('invitation');
        videoIdentStore.$reset();
        videoIdentStore.token = token;
      }

      // if (params.has('invitation') && params.get('invitation') === videoIdentStore.token) {
      // If the user is already know to be invited, do nothing.
      // This is for the edge cases where an "additional user" reloads the browser after
      // having been navigated to "further-information" or "id-registration-confirmation".
      if (! this.isInvitedUser) {
        if (params.has('invitation')){
          videoIdentStore.token = params.get('invitation');
          this.currentLanguage = params.has('vi-lang') ? params.get('vi-lang').toUpperCase() : 'DE';
          this.isInvitedUser = true;
        } else {
          this.isInvitedUser = false;
        }
      }
      // }

    }
  },
  persist: {
    storage: sessionStorage,
  }
});
